<template>
    <div>
        <div class="h1">
        </div>
        <div>
            <img @click="to_api()" style="width: 100%;height: 3.54rem;" src="../assets/imgs/qiwei101/002.gif" alt="">
        </div>
    </div>
</template>
<!-- mounted() {
    this.adid = this.$route.query.adid
    this.creativeid = this.$route.query.creativeid
    this.creativetype = this.$route.query.creativetype
    this.clickid = this.$route.query.clickid
    this.code = this.$route.query.code
    if (this.$route.query.adid == undefined) {
        this.adid = null
    }
    if (this.$route.query.creativeid == undefined) {
        this.creativeid = null
    }
    if (this.$route.query.creativetype == undefined) {
        this.creativetype = null
    }
    if (this.$route.query.clickid == undefined) {
        this.clickid = null
    }
}, -->
<script>
import axios from "axios"
// import { testdata } from '@/api/userApi.js'
export default {
    data() {
        return {
            adid: "",
            creativeid: "",
            creativetype: "",
            clickid: ""
        }
    },
    mounted() {
        this.adid = this.$route.query.adid
        this.creativeid = this.$route.query.creativeid
        this.creativetype = this.$route.query.creativetype
        this.clickid = this.$route.query.clickid

    },
    methods: {
        to_api() {
            let data = {
                adid: this.adid,
                creativeid: this.creativeid,
                creativetype: this.creativetype,
                clickid: this.clickid,
                code: this.$route.query.code,

            }
           axios({method: "GET",url:'https://dy01.txcfgl.net:10081/v1/clutter/resourcesCheck?livecode='+data.code}).then(res=>{
           	if(res.data.data==1){
           		axios({
           		    method: "GET",
           		    url: "https://dy01.txcfgl.net:10081/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
           		    // url: "http://172.16.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
           		}).then(ress => {
           		
           		    setTimeout(() => {
           		        window.location.href = ress.data.data
           		    }, 300);
           		})
           	}else{
           		window.location.href ="https://www.txcfgdd666.com/kongbai"
           	}
           })
            
        },
        // test(){
        // 	let param={
        //         adid: this.$route.query.adid,
        //         creativeid: this.$route.query.creativeid,
        //         creativetype: this.$route.query.creativetype,
        //         clickid: this.$route.query.clickid,
        //         code: this.$route.query.code,
        // 	}
        // 	testdata(param).then(res=>{
        //         console.log(res);
        //         // window.location.href = res.data.url

        // 	})
        // }
    },

}
</script>

<style>
.h1 {
    width: 100%;
    height: 7.8rem;
    background: url(../assets/imgs/ziyuan111/111.jpg);
    background-size: 100% 100%;
}

.imgs {
    padding-left: .5rem;
    padding-top: 7.83rem;
}

img {
    width: 6.5rem;
    height: 1.30rem;
}
</style>